import "./App.css";

import React, { useState, useEffect } from "react";
import logo from "./logo.png";

import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import NearbyErrorIcon from "@mui/icons-material/NearbyError";

import DateFnsUtils from "@date-io/date-fns";

import { Dots } from "react-activity";
import "react-activity/dist/library.css";

import { initializeApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  onSnapshot,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";

const theme = createTheme({
  palette: {
    primary: {
      main: "#ad1010",
    },
    secondary: {
      main: "#ad1010",
    },
  },
});

// Import the functions you need from the SDKs you need

// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD7-HD6W8PntY4RYtt0hDe1PgOWfXFVzbk",
  authDomain: "lo-dni-otwarte-a0f00.firebaseapp.com",
  projectId: "lo-dni-otwarte-a0f00",
  storageBucket: "lo-dni-otwarte-a0f00.appspot.com",
  messagingSenderId: "115504241439",
  appId: "1:115504241439:web:36eb4b619e2c1ef121ae2a",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

function App() {
  //960px

  const [error, setError] = useState(null);
  const [submitError, setSubmitError] = useState(null);

  const [endPage, setEndPage] = useState(null);
  const [globalObj, setGlobalObj] = useState(null);
  const [wolneMiejsca, setWolneMiejsca] = useState(null);

  const [hour, setHour] = useState("");
  const [email, setEmail] = useState(null);
  const [visitorsNumber, setVisitorsNumber] = useState(null);
  const [fullName, setFullName] = useState(null);
  const [checkBox, setCheckBox] = useState(false);

  const [loading, setLoading] = useState(false);
  const [inputHandler, setInputHandler] = useState(null);

  useEffect(() => {
    onSnapshot(collection(db, "main"), (snapshot) => {
      let outObj = {};
      snapshot.forEach((doc) => {
        console.log(doc.id, "=>", doc.data());
        outObj[doc.id] = doc.data();
      });
      setGlobalObj(outObj);
    });
  }, []);

  useEffect(() => {
    if (hour) {
      setWolneMiejsca(globalObj[hour].wolneMiejsca);
    }
  }, [hour]);

  useEffect(() => {
    if (inputHandler) {
      if (isNaN(inputHandler)) {
        setError("Wprowadź poprawną liczbę");
      } else if (inputHandler > 3) {
        setError("Wprowadź mniejszą liczbę");
      } else if (inputHandler < 1) {
        setError("Wprowadź większą liczbę");
      } else {
        setVisitorsNumber(Number(inputHandler));
        setError(null);
      }
    }
  }, [inputHandler]);

  const hours = [
    {
      value: "16.00",
      label: "16:00",
    },
    {
      value: "16.15",
      label: "16:15",
    },
    {
      value: "16.30",
      label: "16:30",
    },
    {
      value: "17.15",
      label: "17:15",
    },
    {
      value: "17.30",
      label: "17:30",
    },
    {
      value: "17.45",
      label: "17:45",
    },
  ];

  const onSubmit = async () => {
    if (email && visitorsNumber && fullName && hour) {
      if (!checkBox) {
        setSubmitError("Zaznacz pole - 'Wyrażam Zgodę'");
        setLoading(false);
      } else {
        if (visitorsNumber <= wolneMiejsca) {
          try {
            updateDoc(doc(db, "main", hour), {
              rezerwacje: arrayUnion({
                liczbaOdwiedzających: visitorsNumber,
                imię: fullName,
                email: email,
              }),
              wolneMiejsca: wolneMiejsca - visitorsNumber,
            }).then(() => {
              updateDoc(doc(db, "output", "submain"), {
                rezerwacje: arrayUnion({
                  email: email,
                  imię: fullName,
                  godzina: hour,
                  liczbaOdwiedzających: visitorsNumber,
                }),
              }).then(() => {
                setTimeout(() => {
                  setLoading(false);
                  setEndPage(true);
                }, 500);
              });
            });
          } catch (e) {
            setLoading(false);
          }
        } else {
          setLoading(false);
        }
      }
    } else {
      setSubmitError("Wypełnij wszystkie pola");
      setLoading(false);
    }
  };

  if (endPage) {
    return (
      <div className="endPage">
        <h1>Dziękujemy za złożenie zerezwacji</h1>
        <p>
          Dziękujemy za rejestrację na Drzwi Otwarte I LO w terminie 11
          kwietnia. W przypadku ewentualnych pytań prosimy o kontakt pod adresem
          info@lo1.elodz.edu.pl
          <br /> Do zobaczenia w szkole!
        </p>
        <div className={"textBox"}>
          <img src={logo} className="App-logo" alt="logo" />
          <h2>
            I LICEUM OGÓLNOKSZTAŁCĄCE IM. M. KOPERNIKA UL. WIĘCKOWSKIEGO 41,
            90-734 ŁÓDŹ
          </h2>
          <div className={"spacer"} />
          <h2>info@lo1.elodz.edu.pl</h2>
        </div>
      </div>
    );
  }

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <ThemeProvider theme={theme}>
        <div className="App">
          <header className="App-header">
            <div className="right">
              <img src={logo} className="App-logo" alt="logo" />
              <TextField
                id="margin-none"
                className="input"
                label="Imię i nazwisko"
                variant="outlined"
                color="primary"
                onChange={(e) => setFullName(e.target.value)}
              />

              <TextField
                id="margin-none"
                className="input"
                label="Email (adres kontaktowy)"
                variant="outlined"
                onChange={(e) => setEmail(e.target.value)}
              />

              <TextField
                id="margin-none"
                className="input"
                label="Liczba osób odwiedzających (1 do 3)"
                variant="outlined"
                onChange={(e) => setInputHandler(e.target.value)}
                inputProps={{ inputMode: "numeric", pattern: "[1-3]*" }}
                error={error}
                helperText={error}
              />
              <TextField
                id="outlined-select-hour"
                select
                label="Godzina spotkania"
                value={hour}
                onChange={(e) => setHour(e.target.value)}
              >
                {hours.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              {hour ? (
                <div className="wolneMiejsca">
                  <p>{"Liczba wolnych miejsc"}</p>
                  <p className="wolneMiejscaHolder"> {wolneMiejsca}</p>
                </div>
              ) : null}
              <div className={"politykaPrywatności"}>
                <div className={"top"}>
                  <Checkbox
                    onClick={() => setCheckBox((prevState) => !prevState)}
                    className="checkBox"
                    sx={{
                      color: "#ad1010",
                      "&.Mui-checked": {
                        color: "#ad1010",
                      },
                    }}
                  />
                  <p>Wyrażam zgodę ...</p>
                </div>
                <p>
                  Zapisując się na Drzwi Otwarte, wyrażam zgodę na przetwarzanie
                  moich danych osobowych przez I Liceum Ogólnokształcące w Łodzi
                  w celach związanych z promocją szkoły.
                </p>
                <p className="marker">
                  Prosimy o rozważny wybór godziny oraz jej zanotowanie.{" "}
                </p>
              </div>

              <Button
                onClick={() => {
                  setLoading(true);
                  onSubmit();
                }}
                variant="contained"
              >
                {loading ? (
                  <Dots />
                ) : (
                  <p className={"buttonText"}>Złoż Rezerwację</p>
                )}
              </Button>
              {submitError ? (
                <div className={"errorContainer"}>
                  <NearbyErrorIcon color="primary" />
                  <p>{submitError}</p>
                </div>
              ) : null}
            </div>
            <div className="left">
              <div className="leftTextbox">
                <h1 className="poppins-regular">Drzwi Otwarte w I LO</h1>
                <p className="poppins-light">
                  Zapraszamy do wzięcia udziału w stacjonarnych Drzwiach
                  Otwartych w I Liceum Ogólnokształcącym im. M. Kopernika w
                  Łodzi.
                </p>
                <p className="poppins-light">
                  Odbędą się one w czwartek  <mark>11 kwietnia</mark>.
                </p>
                <p className="poppins-light">
                  Prosimy o dokonanie rejestracji na daną godzinę. Zostaną
                  Państwo przydzieleni do konkretnej grupy, która zostanie
                  oprowadzona po szkole przez naszych uczniów.
                </p>
                <p className="poppins-light">
                  Wejścia kolejnych grup rozpoczynają się od godz. 16:00 do
                  17:30. Spacer po szkole planowany jest na{" "}
                  <mark>90-120 minut</mark>.
                </p>
                <p className="poppins-light">
                  Prosimy zapisać godzinę, na którą się Państwo rejestrują,
                  ponieważ nie jesteśmy w stanie wysyłać mailowych potwierdzeń
                  rejestracji.
                </p>
                <p className="poppins-light">
                  Podczas Drzwi Otwartych ósmoklasiści i rodzice będą mogli
                  zapoznać się z naszą ofertą edukacyjną, zwiedzić szkołę oraz
                  porozmawiać z dyrekcją, nauczycielami i uczniami.
                </p>
                <p className="poppins-light">
                  W przypadku ewentualnych pytań prosimy o kontakt pod adresem
                  info@lo1.elodz.edu.pl
                </p>
                <p className="poppins-medium-italic">Do zobaczenia!</p>
              </div>
            </div>
          </header>
        </div>
      </ThemeProvider>
    </MuiPickersUtilsProvider>
  );
}

export default App;
